<script lang="ts">
    import { chart } from "svelte-apexcharts";
    import { column } from "../../../Data/Chart/Dashboard/Ecommerce/Chart";
</script>

<div class="media">
    <div class="activity-dot-primary" />
    <div class="media-body d-block">
        <div class="hospital-small-chart">
            <div id="column-chart">
                <div use:chart={column} />
            </div>
        </div>
    </div>
</div>
